import { AddressCardFields } from "lib/types/address";
import { Value as PhoneInputValueType } from "react-phone-number-input";

export type AuthIdentifier = {
  oid: string;
  oid_type: "EMAIL" | "PHONE";
  verified: boolean;
};

export type UserType = {
  uid: string;
  email?: string;
  phone: PhoneInputValueType;
  name?: string;
  default_billing_address?: AddressCardFields;
  default_shipping_address?: AddressCardFields;
  addresses?: AddressCardFields[];
  hasHomeAddr?: boolean;
  hasWorkAddr?: boolean;
  marketing_consent?: boolean;
  authIdentifiers?: AuthIdentifier[];
  metadata?: {
    first_name?: string;
    last_name?: string;
  };
};

export type UserLoginType = "guest_login" | "return_user_login" | "cookie_login" | "na";

export type OTPChannel = "SMS" | "WHATSAPP" | "EMAIL";

export type OTPVerificationDetails = {
  identifier: string;
  merchantId: string;
  userId?: string;
  skipVerification?: boolean;
  forceVerification?: boolean;
  domain?: string;
};

export enum AuthSource {
  "SHOPFLO" = "SHOPFLO",
  "CUSTOM" = "CUSTOM",
}

export type UserHistoryType = "NEW" | "OLD" | "NA";
